import { Directive } from '@angular/core';
import { DropdownGeneralService, DropdownExplotacionService, DropdownEspecieService, DropdownEspeciePRService, DropdownMesService } from '../components/dropdown-general/dropdown-general.service';

@Directive({
  selector: '[dropExplotacion]',
  providers: [{ provide: DropdownGeneralService, useClass: DropdownExplotacionService }]
})
export class DropExplotacionDirective {

  constructor() { }

}

@Directive({
  selector: '[dropEspecie]',
  providers: [{ provide: DropdownGeneralService, useClass: DropdownEspecieService }]
})
export class DropEspecieDirective {

  constructor() { }

}

@Directive({
  selector: '[dropEspeciePR]',
  providers: [{ provide: DropdownGeneralService, useClass: DropdownEspeciePRService }]
})
export class DropEspeciePRDirective {

  constructor() { }

}

@Directive({
  selector: '[dropMes]',
  providers: [{ provide: DropdownGeneralService, useClass: DropdownMesService }]
})
export class DropMesDirective {

  constructor() { }

}

